/**
 * ind-related-products.js
 *
 * Controller for the IND Related Products section (blog articles).
 * Intercepts the quick add-to-cart form on each product card, adds via the
 * Ajax Cart API, and opens the cart drawer instead of letting the native
 * form submit navigate to /cart.
 *
 * Delegated listener on document so the controller survives any section
 * re-render (Shopify editor swaps section innerHTML on save).
 */
(function () {
  'use strict';

  if (window.__indRelatedProductsInit) return;
  window.__indRelatedProductsInit = true;

  async function addToCart(payload) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.description || 'Cart add failed: ' + response.status);
    }
    return response.json();
  }

  function openCartDrawer() {
    // Must dispatch cart:refresh rather than calling drawer.show() directly:
    // show() only toggles visibility, the actual re-fetch of cart contents
    // happens in cart-drawer's cart:refresh listener (assets/cart.js
    // CartDrawer.onCartRefresh), which also opens the drawer once refreshed.
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true },
    }));
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.ind-related-products__atc');
    if (!form) return;

    event.preventDefault();

    const idField = form.querySelector('input[name="id"]');
    const qtyField = form.querySelector('input[name="quantity"]');
    const variantId = Number(idField && idField.value);
    if (!variantId) {
      console.warn('[ind-related-products] Missing variant id');
      return;
    }
    const quantity = Math.max(1, parseInt((qtyField && qtyField.value) || '1', 10) || 1);

    const btn = form.querySelector('button[type="submit"]');
    const originalText = btn ? btn.textContent : null;

    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }

    try {
      await addToCart({ id: variantId, quantity: quantity });
      openCartDrawer();
    } catch (err) {
      console.error('[ind-related-products] Add to cart failed', err);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (originalText != null) btn.textContent = originalText;
      }
    }
  });
})();
